import { render, staticRenderFns } from "./CurrencyFilter.vue?vue&type=template&id=2e1e0c3e&"
import script from "./CurrencyFilter.vue?vue&type=script&lang=js&"
export * from "./CurrencyFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports